import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

export const useProfessions = () => {
    return useQuery({
        queryKey: ["professions"],
        queryFn: async () => {
            const res = await api.get("/Professions");
            return res.data;
        },
        retry: 3,
        staleTime: 1000 * 60 * 5,
    });
};
